import { useInvalidateRepositoryQueries as useInvalidateRepositoryQueriesRaw } from '@mews/framework';
import { RepositoryRegistry } from '../createRegistry';

export type InvalidateQueries = {
    [RepositoryName in keyof RepositoryRegistry]?: Array<keyof RepositoryRegistry[RepositoryName]>;
};

export const useInvalidateRepositoryQueries = useInvalidateRepositoryQueriesRaw<RepositoryRegistry>;
